import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Supplies } from './pages/Supplies';
import { Inventory } from './pages/Inventory';
import { Recipes } from './pages/Recipes';
import { RecipeDetail } from './pages/RecipeDetail';
import { SaleRegistration } from './pages/SaleRegistration';
import { SalesHistory } from './pages/SalesHistory';
import { Quotes } from './pages/Quotes';
import { Profile } from './pages/Profile';
import { Users } from './pages/admin/Users';
import { QuoteFormatSettings } from './pages/admin/QuoteFormatSettings';
import { Categories } from './pages/admin/Categories';
import { Units } from './pages/admin/Units';
import { Settings } from './pages/admin/Settings';
import { NotFound } from './pages/NotFound';
import { PlatformAdmin } from './pages/admin/PlatformAdmin';

export default function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/platform"
              element={
                <ProtectedRoute platformOnly>
                  <PlatformAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/insumos" element={<Supplies />} />
              <Route path="/inventario" element={<Inventory />} />
              <Route path="/recetas" element={<Recipes />} />
              <Route path="/recetas/:id" element={<RecipeDetail />} />
              <Route path="/ventas" element={<SaleRegistration />} />
              <Route path="/calculadora" element={<Navigate to="/ventas" replace />} />
              <Route
                path="/historial"
                element={
                  <ProtectedRoute adminOnly>
                    <SalesHistory />
                  </ProtectedRoute>
                }
              />
              <Route path="/cotizaciones" element={<Quotes />} />
              <Route path="/perfil" element={<Profile />} />
              <Route
                path="/admin/formato-cotizacion"
                element={
                  <ProtectedRoute adminOnly>
                    <QuoteFormatSettings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/usuarios"
                element={
                  <ProtectedRoute adminOnly>
                    <Users />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/categorias"
                element={
                  <ProtectedRoute adminOnly>
                    <Categories />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/unidades"
                element={
                  <ProtectedRoute adminOnly>
                    <Units />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/configuracion"
                element={
                  <ProtectedRoute adminOnly>
                    <Settings />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}
